import { createStore, getActionIds } from '../helpers/redux';
import Immutable from 'immutable';
import { UserActions } from '../actions/user';
import { OrganizationActions } from '../actions/organization';
import { AccountActions } from '../actions/account';

const userActions = getActionIds(UserActions);
const organizationActions = getActionIds(OrganizationActions);
const accountActions = getActionIds(AccountActions);

const initialState = Immutable.fromJS({
  roles: {},
});

export const roles = createStore(initialState, {
  [userActions.getProjectUsers.success]: (state, action) => {
    return state.mergeDeep({
      roles: action.result.entities.roles,
    });
  },

  [organizationActions.getOrganizationUsers.success]: (state, action) => {
    return state.mergeDeep({
      roles: action.result.entities.roles,
    });
  },

  [accountActions.getAccountUsers.success]: (state, action) => {
    return state.mergeDeep({
      roles: action.result.entities.roles,
    });
  },
});



// WEBPACK FOOTER //
// ./src/reducers/roles.js